import { useNavigate } from "react-router-dom";
import { getRoute } from "../components/common/NetworkLink";
import { useNetworkRoute } from "./useNetworkRoute";

type NavigateToUrlProps = {
  path: string;
  fragment?: string;
};

/**
 * Similar to the NetworkLink component,
 * but returns a function that can be used to programmatically navigate to a URL.
 *
 * @returns
 */

const useNetworkNavigate = () => {
  const navigate = useNavigate();

  const [type, value] = useNetworkRoute();

  const navigateToUrl = ({ path, fragment }: NavigateToUrlProps) => {
    const route = getRoute(path, type, value, fragment);
    navigate(route);
  };

  return { navigate: navigateToUrl };
};

export default useNetworkNavigate;
